import { HoverInfo } from "../../../components/core/basic/Tooltip";
import { useTranslation } from "react-i18next";

export const TooltipSearchability = () => {
  const { t } = useTranslation(["metrics"]);
  return <HoverInfo iconCss={{ display: "inline" }}>{t(($) => $.metrics.byId.seo_score.toolTip)}</HoverInfo>;
};

export const TooltipBuyability = () => {
  const { t } = useTranslation(["metrics"]);
  return <HoverInfo iconCss={{ display: "inline" }}>{t(($) => $.metrics.byId.buyability_score.toolTip)}</HoverInfo>;
};
